import { Star, Quote } from 'lucide-react';

export default function Testimonials() {
  const testimonials = [
    {
      rating: 5,
      text: 'Kan Deep AI transformed our legacy infrastructure into a modern, scalable cloud platform. Their technical expertise and commitment to deadlines were exceptional. The team went above and beyond to ensure our success.'
    },
    {
      rating: 5,
      text: 'Outstanding development team with deep expertise in financial systems. They delivered a secure, compliant mobile banking solution that exceeded our expectations. Their attention to security and regulatory requirements was impressive.'
    },
    {
      rating: 5,
      text: 'The patient management system they built has revolutionized our operations. Seamless integration, intuitive design, and robust functionality. Their healthcare domain knowledge made all the difference.'
    },
    {
      rating: 5,
      text: 'Kan Deep AI helped us achieve true omnichannel retail capabilities. The e-commerce platform they developed handles our massive traffic seamlessly. Their agile approach allowed us to launch ahead of schedule.'
    },
    {
      rating: 5,
      text: 'Their IoT and predictive maintenance solution has saved us millions. The team understood our complex manufacturing processes and delivered a system that actually works in the real world. Highly recommended.'
    },
    {
      rating: 5,
      text: 'Working with Kan Deep AI was a game-changer for our e-learning platform. They delivered a scalable solution that supports millions of students. Their innovation and problem-solving skills are world-class.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-50 rounded-full mb-4">
            <span className="text-blue-600 font-semibold text-sm">CLIENT TESTIMONIALS</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            What Our Clients{' '}
            <span className="bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
              Say About Us
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Hear from the leaders who have partnered with us to achieve digital transformation success.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300"
            >
              <Quote className="w-10 h-10 text-blue-600 opacity-20 mb-4" />

              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                ))}
              </div>

              <p className="text-gray-700 leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>

              
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-2xl p-12 text-center">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-3xl font-bold text-white mb-4">Join 100+ Satisfied Clients Worldwide</h3>
            <p className="text-xl text-blue-50 mb-8">
              Experience the same level of excellence and commitment that has earned us a 99% client satisfaction rate.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="px-8 py-4 bg-white text-blue-600 rounded-lg font-semibold hover:shadow-xl transition-all duration-300"
              >
                Start Your Project
              </button>
              <button className="px-8 py-4 bg-blue-700 text-white rounded-lg font-semibold hover:bg-blue-800 transition-all duration-300">
                View More Testimonials
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
